//
//
//
//
//
//
//
//
//
//
//
//
//

// import PhoneCodeDialog from './PhoneCodeDialog';
import AreaCodeSelector from '../AreaCodeSelector/AreaCodeSelector';

export default {
  name: 'phone-code',
  components: {
    // PhoneCodeDialog,
    AreaCodeSelector,
  },
  props: {
    defaultCode: String | Number,
  },
  data(){
    return {
      isShowAreaSelector: false,   // 显示地区号选择器
      // openDialog: false,
      code: '',
    }
  },
  methods: {
    onShowSelector(){
      this.isShowAreaSelector = true;
    },

    onGetCode(code){
      this.code = code;
      this.$emit('on-change-code', code);
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/PhoneCode/PhoneCode.vue